import { useEffect } from 'react'
import { BackHandler } from 'react-native'
import { ConfirmationModal, ConfirmationModalOption, useToastController } from '@my/ui'
import { useDeletePost } from './commands'
import { userFeedQuery } from '../../screens/groups-feed-screen/queries'
import { useRouter } from 'solito/router'

export interface DeleteGroupPostModalContainerProps {
  type: 'post' | 'event'
  groupPostId: string
  groupId: string
  userId: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onAfterDelete?: () => void
}

export const DeleteGroupPostModalContainer = (props: DeleteGroupPostModalContainerProps) => {
  const [deletePost, { loading }] = useDeletePost()
  const toast = useToastController()
  const router = useRouter()

  useEffect(() => {
    const backAction = () => {
      props.onOpenChange(false)
      return props.open
    }

    const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction)

    return () => backHandler.remove()
  }, [])

  const handleSubmit = async () => {
    try {
      await deletePost({
        variables: {
          groupPostId: props.groupPostId,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: userFeedQuery.query,
            variables: {
              ...userFeedQuery.defaultVariables,
            },
          },
        ],
        onCompleted: () => {
          toast.show(`${props.type === 'post' ? 'Post' : 'Event'} deleted successfully`)
          props.onOpenChange(false)
          props.onAfterDelete && props.onAfterDelete()
          router.push('/groups/feed')
        },
      })
    } catch (error) {
      toast.show(`Failed to delete ${props.type}`, {
        burntOptions: { preset: 'error' },
      })
      console.error(error)
    }
  }

  const options: ConfirmationModalOption[] = [
    {
      children: 'Yes, Delete it',
      theme: 'black',
      onPress: handleSubmit,
      loading,
    },
    {
      children: 'No, Discard',
      plain: true,
      onPress: () => props.onOpenChange(false),
    },
  ]

  return (
    <ConfirmationModal
      title={`Are you sure you want to delete this ${props.type}?`}
      open={props.open}
      onOpenChange={props.onOpenChange}
      onSubmit={handleSubmit}
      options={options}
    />
  )
}
